import {
  getTaxSettings as publicGetTaxSettings,
  upsertTaxSettings as publicUpsertTaxSettings,
} from './billing-tax-v1-tax-settings-tax-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getTaxSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetTaxSettings> & typeof publicGetTaxSettings
> = /*#__PURE__*/ createRESTModule(publicGetTaxSettings);
export const upsertTaxSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpsertTaxSettings> &
    typeof publicUpsertTaxSettings
> = /*#__PURE__*/ createRESTModule(publicUpsertTaxSettings);

export { WebhookIdentityType } from './billing-tax-v1-tax-settings-tax-settings.universal.js';
export {
  TaxSettings,
  GetTaxSettingsRequest,
  GetTaxSettingsResponse,
  UpsertTaxSettingsRequest,
  UpsertTaxSettingsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
} from './billing-tax-v1-tax-settings-tax-settings.universal.js';
export { WebhookIdentityTypeWithLiterals } from './billing-tax-v1-tax-settings-tax-settings.universal.js';
